import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {
    Button,
} from 'react-weui'
import {
    Page,
    Preload,
    WKError
} from '../components'
import {renderMoney, TimeStream} from '../utils';
import '../styles/giftcard/GiftCardDetail.css'
import qs from 'qs';
import Config from '../config';
import errorImg from '../images/nodiscount.png';

class GiftCardAcceptPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            account: '',
            gift: '',
            target: '',
            initialized: false,
            giftAcceptType: '',
            giftAcceptId: '',
            giftSign: '',
        };
        this.handleAccept = this.handleAccept.bind(this)
    }

    handleAccept() {
        const {giftAcceptType, giftAcceptId, giftSign} = this.state;
        let data = {type: giftAcceptType, gift_id: giftAcceptId, sign: giftSign};

        axios.post(`/api/gift/accept`, qs.stringify(data)).then((response) => {
            if (response.data.code === 0) {
                const data = response.data.data;
                const targetId = data.target_id;
                if (giftAcceptType === 'lecture') {
                    window.location.href = Config.MAIN_URL + `/lecture/pay_success?lecture_id=${targetId}&st=accept_gift`;
                } else {
                    window.location.href = Config.MAIN_URL + `/liveroom/pay_success?channel_id=${targetId}&st=accept_gift`;
                }
            }
        });
    }

    componentDidMount() {
        let params = this.props.params
        this.setState({
            giftAcceptType: params.type,
            giftAcceptId: params.gift_card_accept_id,
            giftSign: params.sign,
        })
        axios.get(`/api/gift/accept_info?type=${params.type}&gift_id=${params.gift_card_accept_id}&sign=${params.sign}`).then((response) => {
            if (response.data.code === 0) {
                const {account, gift, target} = response.data.data;
                this.setState({
                    account: account,
                    gift: gift,
                    target: target,
                    initialized: true,
                });
            } else {
                const {target} = response.data.data;
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: response.data.msg,
                        img: errorImg,
                        href: params.type === 'lecture' ? Config.MAIN_URL + `/lecture/?lecture_id=${target}` : Config.MAIN_URL + `/channel/${target}`,
                        btn: params.type === 'lecture' ? '回到课程' : '回到专栏'
                    }
                });
            }
        });
    }

    render() {
        const {initialized, account, gift, target} = this.state;
        let type = this.props.params.type

        const {error} = this.props;
        if (error.showError) {
            return (
                <div className="gift-error-page">
                    <WKError />
                </div>
            )
        }

        if (!initialized) {
            return <Preload />
        }

        return (
            <Page className="gift-card-accept-page">
                <div className="gift-card-detail-bg">
                    <div className="gift-card-detail-tip">
                        <img src={account.small_avatar_url} alt=""/>
                        <span>{account.nickname}送你{type === "lecture" ? '一节课' : '一个专栏'}</span>
                        <div className="gift-card-accept-gap bottom-left"></div>
                        <div className="gift-card-accept-gap bottom-right"></div>
                    </div>
                    <div className="gift-card-detail-content">
                        <div className="gift-card-accept-gap top-left"></div>
                        <div className="gift-card-accept-gap top-right"></div>
                        <div className="gift-card-detail-img">
                            <img src={target.cover_url} alt=""/>
                        </div>
                        <div className="gift-card-detail-title">{this.state.target.name}</div>
                        <div className="gift-card-detail-time">
                            <div className="gift-card-detail-detail">
                                <span>讲师：{target.lecturer}</span>
                                {type === 'lecture' &&
                                <span>时间：{TimeStream(target.start_timestamp)}</span>
                                }
                            </div>
                            <div className="gift-card-detail-money"><span>¥{renderMoney(gift.single_price)}</span>&#40;已付款&#41;
                            </div>
                        </div>
                        <Button className="gift-card-detail-button" onClick={this.handleAccept}>领取赠礼</Button>
                    </div>
                </div>
            </Page>
        );
    }
}

export default connect(state => ({
    error: state.error,
}))(GiftCardAcceptPage)


// WEBPACK FOOTER //
// ./src/pages/GiftCardAcceptPage.js